var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "flex w-full overflow-x-hidden",
      attrs: { id: "form-activity", autocomplete: "off" }
    },
    [
      _c(
        "div",
        { staticClass: "w-full p-2 form-content" },
        [
          _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
            _c("div", { staticClass: "px-4 mb-6" }, [
              _c("img", {
                staticClass:
                  "shadow rounded max-w-full h-auto align-middle border-none",
                staticStyle: { width: "150px" },
                attrs: {
                  alt: "...",
                  src: _vm.input.thumbnail
                    ? _vm.input.thumbnail
                    : _vm.imgPlaceholder
                }
              })
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.isFileLarge ||
            _vm.isFileWrongFormat ||
            (_vm.$v.input.thumbnail.$dirty && !_vm.$v.input.thumbnail.required)
              ? _c(
                  "div",
                  { staticClass: "flex flex-col mb-2" },
                  [
                    _vm.isFileLarge
                      ? _c("text-error", {
                          attrs: { text: "Please using image lower than 1MB" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isFileWrongFormat
                      ? _c("text-error", {
                          attrs: { text: "Invalid image size" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.input.thumbnail.$dirty &&
                    !_vm.$v.input.thumbnail.required
                      ? _c("text-error", {
                          attrs: { text: "Please select video thumbnail." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                !_vm.input.thumbnail
                  ? _c("Button", {
                      attrs: { label: "Browse File" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "any",
                            fn: function() {
                              return [
                                _c("input", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                    position: "absolute",
                                    left: "0",
                                    top: "0",
                                    opacity: "0",
                                    cursor: "pointer",
                                    "z-index": "2"
                                  },
                                  attrs: {
                                    type: "file",
                                    name: "profile_picture"
                                  },
                                  on: { change: _vm.onFileChange }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2462335240
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.input.thumbnail
                  ? _c("Button", {
                      attrs: { label: "Remove", variant: "default" },
                      on: { clicked: _vm.changeImage }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Video Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "ex. Video Name",
                        error:
                          _vm.$v.input.name.$dirty &&
                          (!_vm.$v.input.name.required ||
                            !_vm.$v.input.name.maxLength),
                        maxlength: "100"
                      },
                      model: {
                        value: _vm.input.name,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "name", $$v)
                        },
                        expression: "input.name"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.name.$dirty && !_vm.$v.input.name.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill Video Name." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.name.$dirty && !_vm.$v.input.name.maxLength
                          ? _c("text-error", {
                              attrs: {
                                text: "Max length Video name is 100 character."
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Video Description" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "relative" },
                      [
                        _c("TextArea", {
                          attrs: {
                            placeholder: "Description Video",
                            error:
                              _vm.$v.input.description.$dirty &&
                              (!_vm.$v.input.description.required ||
                                !_vm.$v.input.description.maxLength),
                            rows: "5"
                          },
                          model: {
                            value: _vm.input.description,
                            callback: function($$v) {
                              _vm.$set(_vm.input, "description", $$v)
                            },
                            expression: "input.description"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "absolute right-0 text-xs",
                            staticStyle: { bottom: "15px", right: "15px" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.input.description.length) +
                                "/" +
                                _vm._s(_vm.maxLengthDesc)
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.description.$dirty &&
                        !_vm.$v.input.description.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill the Description." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.description.$dirty &&
                        !_vm.$v.input.description.maxLength
                          ? _c("text-error", {
                              attrs: {
                                text:
                                  "Max length description channel is 750 character"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Type" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Select", {
                      attrs: {
                        "empty-label": "Select Type",
                        error:
                          _vm.$v.input.type.$dirty &&
                          !_vm.$v.input.type.required,
                        data: [
                          { value: "mission", label: "Mission" },
                          { value: "podcast", label: "Podcast" }
                        ]
                      },
                      model: {
                        value: _vm.input.type,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "type", $$v)
                        },
                        expression: "input.type"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.type.$dirty && !_vm.$v.input.type.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill the Type." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Category" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      [
                        _vm._l(_vm.$v.input.category_list.$each.$iter, function(
                          v,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: "cat-" + index,
                              staticClass: "flex flex-col mb-4"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("Select", {
                                    attrs: {
                                      "empty-label": "All Categories",
                                      error: v.id.$dirty && !v.id.required,
                                      data: _vm.categories
                                    },
                                    model: {
                                      value: v.id.$model,
                                      callback: function($$v) {
                                        _vm.$set(v.id, "$model", $$v)
                                      },
                                      expression: "v.id.$model"
                                    }
                                  }),
                                  _vm._v(" "),
                                  index > 0
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "w-10 ml-2 p-1 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeCategory(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "text-white",
                                            attrs: { icon: ["fa", "trash-alt"] }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  v.id.$dirty && !v.id.required
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Please choose category"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex w-full justify-center" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "text-sm focus:outline-none px-4 py-2 rounded font-bold cursor-pointer\n                        hover:bg-blue-700 hover:text-blue-100\n                        text-blue-700\n                          border duration-200 ease-in-out\n                        border-blue-600 transition",
                                on: { click: _vm.addCategory }
                              },
                              [_vm._v("Add another category")]
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Language" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "el-select",
                      {
                        staticClass: "w-full",
                        attrs: {
                          filterable: "",
                          placeholder: "Select Language"
                        },
                        model: {
                          value: _vm.input.language,
                          callback: function($$v) {
                            _vm.$set(_vm.input, "language", $$v)
                          },
                          expression: "input.language"
                        }
                      },
                      _vm._l(_vm.languages, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.language.$dirty &&
                        !_vm.$v.input.language.required
                          ? _c("text-error", {
                              attrs: { text: "Please choose language." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Tag" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "el-select",
                      {
                        staticClass: "w-full",
                        attrs: {
                          multiple: "",
                          filterable: "",
                          remote: "",
                          "allow-create": "",
                          "default-first-option": "",
                          "reserve-keyword": "",
                          size: "large",
                          placeholder: "Please enter a keyword",
                          "remote-method": _vm.searchTags,
                          loading: _vm.loadingTags
                        },
                        model: {
                          value: _vm.tagsValue,
                          callback: function($$v) {
                            _vm.tagsValue = $$v
                          },
                          expression: "tagsValue"
                        }
                      },
                      _vm._l(_vm.tagsOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.tag.$dirty && !_vm.$v.input.tag.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill tag." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap px-4 mt-4 mb-2" }, [
            _vm.$v.input.file.$dirty && !_vm.$v.input.file.required
              ? _c("p", { staticClass: "text-red-500 text-xs" }, [
                  _vm._v("Video cannot be empty.")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "dragDrop",
                staticClass:
                  "relative drag-drop px-3 w-full upload-btn-wrapper",
                on: {
                  drop: function($event) {
                    $event.preventDefault()
                    return _vm.onDrop($event)
                  },
                  dragover: function($event) {
                    $event.preventDefault()
                    _vm.dragover = true
                  },
                  dragenter: function($event) {
                    $event.preventDefault()
                    _vm.dragover = true
                  },
                  dragleave: function($event) {
                    $event.preventDefault()
                    _vm.dragover = false
                  }
                }
              },
              [
                _c("input", {
                  attrs: {
                    type: "file",
                    name: "fileVideo",
                    accept: "video/mp4"
                  },
                  on: { change: _vm.onFileChangeVideo }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "absolute drag-drop-content flex flex-col w-full"
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "icon-drag-drop",
                      attrs: { icon: ["fa", "cloud-upload-alt"] }
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "mb-4" }, [
                      _vm._v("Click or Drag Your Files Here")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.fileVideoPreview
                  ? _c("div", { staticClass: "video-uploaded" }, [
                      _c("div", { staticClass: "video-uploaded-content" }, [
                        _c("video", { attrs: { controls: "" } }, [
                          _c("source", {
                            attrs: {
                              src: _vm.fileVideoPreview,
                              type: "video/mp4"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-sm w-50 m-auto text-center focus:outline-none px-4 py-2 rounded font-bold cursor-pointer\n                        hover:bg-blue-100 hover:text-blue-700\n                        text-blue-100\n                          border duration-200 ease-in-out\n                        border-blue-600 bg-blue-700 transition",
                            on: { click: _vm.replace }
                          },
                          [_vm._v("Replace Video")]
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col mb-2" }, [
      _c("p", { staticClass: "text-xs text-gray-700" }, [
        _vm._v("Thumbnail (960 x 540 px), Maximum 1MB")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b9972c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9972c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionsVideos/Videos/VideosForm.vue
// module id = null
// module chunks = 